/**
 * Navigation actions — controls which tab/screen is active in the project workspace.
 */

// Sets the active tab within a given ancestor level of the tab hierarchy
export const setActiveTab = (current, ancestor) => dispatch => {
  dispatch({ type: "SET_ACTIVE_TAB", current, ancestor });
}

// Navigates to the "process" sub-tab under collections and sets the active collection.
// This is triggered when the user clicks on a data group to configure its column mappings.
export const setCollection = (collection) => dispatch => {
  dispatch(setActiveTab('process', 'collections'));
  dispatch({ type: "SET_COLLECTION", collection });
}